const basic = [
	// ! 单项题
	{
		component: 'DwRadio',
		name: "单项题",
		questionCode: '',
		questionName: '请设置问题题目',
		questionType: '1',
		isRequired: '0',
		defaultValue: '',
		tipsText: '',
		remark: '',
		itemList: [
			{
				itemCode: 'A',
				itemName: '选项一',
				showType: '1'
			},
			{
				itemCode: 'B',
				itemName: '选项二',
				showType: '1'
			}
		],
		ruleList: []
	},
	// ! 多项题
	{
		component: 'DwCheckbox',
		name: "多项题",
		questionCode: '',
		questionName: '请选择一个选项',
		questionType: '2',
		isRequired: '0',
		defaultValue: [],
		tipsText: '',
		remark: '',
		itemList: [
			{
				itemCode: 'A',
				itemName: '选项一',
				showType: '1'
			},
			{
				itemCode: 'B',
				itemName: '选项二',
				showType: '1'
			}
		],
		ruleList: []
	},
	// ! 下拉选择题
	{
		component: 'DwSelect',
		name: "下拉选择题",
		questionCode: '',
		questionName: '请选择一个选项',
		questionType: '6',
		isRequired: '0',
		defaultValue: '',
		tipsText: '',
		remark: '',
		itemList: [
			{
				itemCode: 'A',
				itemName: '选项一',
				showType: '1'
			},
			{
				itemCode: 'B',
				itemName: '选项二',
				showType: '1'
			}
		],
		ruleList: []
	},
	// ! 简答题
	{
		component: 'DwTextarea',
		name: "简答题",
		questionCode: '',
		questionName: '请填写本项内容',
		questionType: '3',
		isRequired: '0',
		defaultValue: '',
		tipsText: '',
		remark: '',
		itemList: [],
		ruleList: []
	},
	// ! 判断题
	{
		component: 'DwJudge',
		name: "判断题",
		questionCode: '',
		questionName: '请选择一个选项',
		questionType: '4',
		isRequired: '0',
		defaultValue: '',
		tipsText: '',
		remark: '',
		itemList: [
			{
				itemCode: 'A',
				itemName: '是',
				showType: '1'
			},
			{
				itemCode: 'B',
				itemName: '否',
				showType: '1'
			}
		],
		ruleList: []
	},
]

export {
	basic
}